import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Container, Dropdown } from 'react-bootstrap';

import Navbar from '../Navbar/NavBar';
import * as DateFns from 'date-fns';
import FiltersPlayerPage from './FiltersPlayerPage';
import Table from '../Shared/CustomTable';
import { text_truncate, fixDecimals, saveDataPlayersOnLocalStorage, isNCAA, fileDownload, getFile, paramBuilder } from '../../helpers/helpers';
import Loader from '../Shared/Loader';
import { useDataPlayersDispatch, useDataPlayersState, useFiltersState, useLoadingState, useUserState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, MESSAGES, ON_EXPORT_ALERT } from '../../config/constants';
import { FiltersState, MetaDataPlayer } from '../../store/types';
import { ContentSpeedRow } from './types';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { message, notification } from 'antd';
import { Player } from 'config/commonTypes';
import store from '../../store';
import { SERVER } from 'config/server.config';

export default () => {

  const user = useUserState();
  const { dataPlayers } = useDataPlayersState();
  const { specificScope, location, scope } = useRouter();
  const {
    [FILTER_KEYS.TEAM_ID]: filterTeamIdData,
    [FILTER_KEYS.POSITIONS]: filterPositionsData,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData,
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks
  } = useFiltersState(specificScope, FILTER_KEYS.TEAM_ID, FILTER_KEYS.POSITIONS, FILTER_KEYS.DATE_RANGE, FILTER_GLOBAL_KEYS.WEEKS);
  const { getDataPlayers: getPlayers } = useDataPlayersDispatch();
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
  const current = useLoadingState(specificScope);

  useEffect(() => {
    if (weeks &&
      (filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length) &&
      ((isNCAA(user)) || (!isNCAA(user) && filterTeamIdData)) &&
      filterPositionsData) {
      getPlayers();
    }
  }, [weeks, filterDateRangeData, filterTeamIdData]);

  useEffect(() => {
    saveDataPlayersOnLocalStorage();
  }, [dataPlayers]);
  const notificationKey = 'downloadFinished';
  const notificationDownload = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download In Progress',
      description:
        `Your file ${name} is being processed.`,
      duration: 0,
      icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadFinish = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download Finished',
      description: `Your file ${name} has been downloaded successfully.`,
      duration: 4,
      icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadError = (name:string) => {
    const args = {
      key: notificationKey,
      message: `Error downloading file ${name}`,
      duration: 4,
      icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
    };
    notification.open(args);
  };



  const exportBulkCSV = async (customer: string, player: string, bulkDataType: string) => {
    const playerScopeData = filterDateRangeData;
    if (!!playerScopeData) {
      fileIsDownloading(true);
      notificationDownload(`${player}_bulk.csv`);
      const yearSelected = filterDateRangeData?.year as number;
      const compareRange = `${DateFns.format(new Date(yearSelected, 2, 1), 'yyyyMMdd')}-${DateFns.format(DateFns.subDays(new Date(yearSelected + 1, 2, 1), 1), 'yyyyMMdd')}`;
      const params: { tzOffset?: number } = {};
      const localDate = new Date();
      params['tzOffset'] = -localDate.getTimezoneOffset();
      const materialize = 'no';
      const sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      };
      let done;    
        do{
          done = await fileDownload (SERVER.CSV_REPORT_BULKDATA(customer, player, bulkDataType, compareRange) + '&' + paramBuilder(params) + `&materialize=${materialize}`);
          if(done === 0){
            await sleep(10);
          }else{
            await sleep(5000);
          } 
        }while(done === 1);
      if (done === 0) {
        const materialize = 'yes';
        await getFile (SERVER.CSV_REPORT_BULKDATA(customer, player, bulkDataType, compareRange) + '&' + paramBuilder(params) + `&materialize=${materialize}`, `${player}_bulk.csv`);
        fileIsDownloading(false);
        notificationDownloadFinish(`${player}_bulk.csv`);
      } else {
        fileIsDownloading(false);
        notificationDownloadError(`${player}_bulk.csv`);
      }
    } else {
      fileIsDownloading(false);
      message.warning({
        content: ON_EXPORT_ALERT,
        className: 'antd-message-alert'
      });
    }
  };
  const headers = [
    { content: 'PLAYER', style: { width: '300px' }, class: 'oo-i', isOrderly: true, leftSortIcon: '71px' },
    { content: 'NO.', style: { width: '51px' }, isOrderly: true },
    { content: 'POS.', style: { width: '81px' }, isOrderly: true },
    /* {content: 'STATUS', style: {width: '53px',} 'll-pp', isOrderly: true}, */
    { content: 'AVG. MAX SPEED', style: { width: '90px' }, class: 'll-pp', isOrderly: true },
    {
      content: 'AVG. MAX SUST. SPEED',
      style: { paddingLeft: '23px', width: '101px' },
      class: 'll-pp',
      isOrderly: true
    },
    { content: 'AVG. TTL. DIST.', style: { width: '76px' }, class: 'll-pp', isOrderly: true },
    // { content: 'AVG. HARD EFF. DIST.', class: 'll-pp', isOrderly: true, style: { width: '82px', paddingLeft: '26px' } },
    { content: 'AVG. ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: '473px' } }
  ];
  const rows = [];
  let positionFilter: string[] = [];
  if(filterPositionsData && filterPositionsData.length > 0){
    positionFilter = filterPositionsData.map(obj => obj.value);
  }
  for (const key in dataPlayers) {
    const player = dataPlayers[key];
    const shouldPush = positionFilter?(positionFilter.length === 0 || positionFilter.includes(player.meta.position)): true;
    if(shouldPush){
    rows.push({
        columns: [
          {
            content: {
              name: player.meta.name,
              playerId: player.meta.playerId
            },
            // class: 'player-img',
            print: (content: MetaDataPlayer) =>
              <Link
                to={{
                  pathname: `/player/${content.playerId}`,
                  search: location.search,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <label className="l-c" style={{ color: '#333d47' }}><b>{text_truncate(content.name, 30)}</b></label>
              </Link>,
            order: (contentA: MetaDataPlayer, contentB: MetaDataPlayer) => {
              if (contentA.name.split(' ').length < 2) {
                return contentA.name.localeCompare(contentB.name);
              }
              const lastNameA = contentA.name.split(' ')[1];
              const lastNameB = contentB.name.split(' ')[1];
              return lastNameA.localeCompare(lastNameB);
            },
            style: {
              // backgroundImage: `url(https://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/${player.eid}.png)`,
              paddingLeft: '20px'
            }
          },
          {
            content: { jersey: player.meta.jersey },
            print: (content:MetaDataPlayer) => <label className="l-c">#{content.jersey}</label>,
            order: (contentA: MetaDataPlayer, contentB: MetaDataPlayer) => {
              const jerseyA =  contentA.jersey.replace(/\D/g, '');
              const jerseyB =  contentB.jersey.replace(/\D/g, '');
              const jerseyLetterA = contentA.jersey.replace(jerseyA, '');
              const jerseyLetterB = contentB.jersey.replace(jerseyB, '');
              if (+jerseyA !== +jerseyB) {
                return +jerseyB- +jerseyA;
                 
              }
              return jerseyLetterB.localeCompare(jerseyLetterA);
              
            }
          },
          {
            content: { position: player.meta.position },
            print: (content:MetaDataPlayer) => <label className="l-c">{content.position}</label>,
            order: (contentA:MetaDataPlayer, contentB:MetaDataPlayer) => contentA.position.localeCompare(contentB.position)
          },
          /*{
            class: 'll-pp',
            content: {status: 'Active'},
            print: (content) => <label className="l-c"> {content.status} </label>,
            order: (contentA, contentB) => contentA.status.localeCompare(contentB.status),
            style: {width: '53px', minWidth: '53px', maxWidth: '53px'}
          },*/
          {
            class: 'll-pp',
            content: {
              printAveSpeedMPH: isNaN(player.metrics.aveMaxSpeedMPH) ? '-' : fixDecimals(player.metrics.aveMaxSpeedMPH, 1),
              aveSpeedMPH: isNaN(player.metrics.aveMaxSpeedMPH) ? -1000000 : fixDecimals(player.metrics.aveMaxSpeedMPH, 1)
            },
            print: (content:ContentSpeedRow) => <label className="l-c">{content.printAveSpeedMPH}</label>,
            order: (contentA:ContentSpeedRow, contentB:ContentSpeedRow) => contentA.aveSpeedMPH - contentB.aveSpeedMPH
          },
          {
            class: 'll-pp',
            content: {
              printAveMaxSustainedSpeedMPH: isNaN(player.metrics.aveMaxSustainedSpeedMPH) ? '-' : fixDecimals(player.metrics.aveMaxSustainedSpeedMPH, 1),
              aveMaxSustainedSpeedMPH: isNaN(player.metrics.aveMaxSustainedSpeedMPH) ? -1000000 : fixDecimals(player.metrics.aveMaxSustainedSpeedMPH, 1)
            },
            print: (content:ContentSpeedRow) => <label className="l-c">{content.printAveMaxSustainedSpeedMPH}</label>,
            order: (contentA:ContentSpeedRow, contentB:ContentSpeedRow) => contentA.aveMaxSustainedSpeedMPH - contentB.aveMaxSustainedSpeedMPH
          },
          {
            class: 'll-pp',
            content: {
              printAveDistYards: isNaN(player.metrics.aveDistYards) ? '-' : fixDecimals(player.metrics.aveDistYards, 0),
              aveDistYards: isNaN(player.metrics.aveDistYards) ? -1000000 : fixDecimals(player.metrics.aveDistYards, 0)
            },
            print: (content:ContentSpeedRow) => <label className="l-c">{content.printAveDistYards}</label>,
            order: (contentA:ContentSpeedRow, contentB:ContentSpeedRow) => contentA.aveDistYards - contentB.aveDistYards
          },
          // {
          //   class: 'll-pp',
          //   content: {
          //     printAveHardEffortDist: isNaN(player.metrics.aveHardEffortDist) ? '-' : fixDecimals(player.metrics.aveHardEffortDist, 0),
          //     aveHardEffortDist: isNaN(player.metrics.aveHardEffortDist) ? -1000000 : fixDecimals(player.metrics.aveHardEffortDist, 0)
          //   },
          //   print: (content) => <label className="l-c">{content.printAveHardEffortDist}</label>,
          //   order: (contentA, contentB) => contentA.aveHardEffortDist - contentB.aveHardEffortDist
          // },
          {
            content: { accelDistAve: player.metrics.accelsAve },
            print: (content:ContentSpeedRow) => <label className="l-c">{fixDecimals(content.accelDistAve, 0)}</label>,
            order: (contentA:ContentSpeedRow, contentB:ContentSpeedRow) => contentA.accelDistAve - contentB.accelDistAve,
            class: 'll-pp'
          },
          {
            content: { deccelDistAve: player.metrics.deccelsAve },
            print: (content:ContentSpeedRow) => <label className="l-c">{fixDecimals(content.deccelDistAve, 0)}</label>,
            order: (contentA:ContentSpeedRow, contentB:ContentSpeedRow) => contentA.deccelDistAve - contentB.deccelDistAve,
            class: 'll-pp'
          },
          {
            content: (
              <div className="t-l" style={{ overflow: 'visible' }}>
              <Dropdown
                className="player-customer-export-button"
              >
                <Dropdown.Toggle id="dropdown-basic" className="btn-blue" disabled={download}>
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => exportBulkCSV(filterTeamIdData as string, key as string, 'practices')} target={'_blank'}>
                    Practice Data Only
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportBulkCSV(filterTeamIdData as string, key, 'games')} target={'_blank'}>
                    Game Data Only
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => exportBulkCSV(filterTeamIdData as string, key, 'practices,games')}
                    target={'_blank'}
                  >
                    Practice/Game Combined
                  </Dropdown.Item>
                  {
                  (player.meta.position === 'QB' || player.meta.position === 'K' || player.meta.position === 'P' || player.meta.position === 'LS') && (
                  <>
                  <Dropdown.Item onClick={() => exportBulkCSV(filterTeamIdData as string, key, 'practiceBallFlights')}
                  target={'_blank'}>
                    Practice Ball
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportBulkCSV(filterTeamIdData as string, key, 'gameBallFlights')}
                  target={'_blank'}>
                    Game Ball
                  </Dropdown.Item>
                  </>
                    )
                  } 
                </Dropdown.Menu>
              </Dropdown>
              <Link
                to={{
                  pathname: `/player/${player.meta.playerId}`,
                  search: location.search,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <Button className="btn-blue"> View Profile</Button>
              </Link>
             </div>
            ),
          }
        ],
        id: key
      }
    );
  }
  }
  return (
    <>
      <Navbar />
      <Container className="container-00">
        <h4 className="h-t">Players</h4>
        <Row>
          <Col lg={12} xs={12}>
            <FiltersPlayerPage />
            <div className="performance-body player-01">
              <Loader forceLoader={current.count > 0 || !weeks} forceMessage={rows.length === 0? MESSAGES.EMPTY : ''}>
                <Table
                  classTable="players-list-table"
                  headers={headers}
                  rows={rows}
                  default={{ orderColumn: -1 }}
                />
              
              </Loader>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
